export default __webpack_public_path__ + "static/1-c6bd20e77e9c57a9fae1530fb4e6dbda.png";